import initialState from './initialState';
import {
  FETCH_CONNECTION_RUN_STATUS,
  FETCH_CONNECTION_RUN_STATUS_SUCCESS,
  FETCH_CONNECTION_RUN_STATUS_FAILURE,
  FETCH_CONNECTION_MONITOR_DATA,
  FETCH_CONNECTION_MONITOR_DATA_SUCCESS,
  FETCH_CONNECTION_MONITOR_DATA_FAILURE,
  FETCH_HEARTBEAT_MONITOR_STATUS,
  FETCH_HEARTBEAT_MONITOR_STATUS_SUCCESS,
  FETCH_HEARTBEAT_MONITOR_STATUS_FAILURE,
} from '../../store/types';

export default function connectionRunStatusReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CONNECTION_RUN_STATUS:
      return {
        ...state,
        connectionsRunStatusLoading: true,
      };
    case FETCH_CONNECTION_RUN_STATUS_SUCCESS:
      return {
        ...state,
        averageRunTime: action.runStatus.averageRunTime || null,
        longestRunTime: action.runStatus.longestRunTime || null,
        shortestRunTime: action.runStatus.shortestRunTime || null,
        heartbeat: action.runStatus.heartbeat || null,
        stats: action.runStatus.stats || [],
        lastUpdated: new Date(),
        connectionsRunStatusLoading: false,
      };
    case FETCH_CONNECTION_RUN_STATUS_FAILURE:
      return {
        ...state,
        connectionsRunStatusLoading: false,
      };
    case FETCH_CONNECTION_MONITOR_DATA:
      return {
        ...state,
        connectionsMonitorDataLoading: true,
      };
    case FETCH_CONNECTION_MONITOR_DATA_SUCCESS:
      return {
        ...state,
        connectionsMonitorDataLoading: false,
        connectionsMonitorData: action.connectionsMonitorData,
        connectionsMonitorUpdateTime: action.connectionsMonitorUpdateTime,
        connectionsOverallStatus: action.overallStatus,
      };
    case FETCH_CONNECTION_MONITOR_DATA_FAILURE:
      return {
        ...state,
        connectionsMonitorDataLoading: false,
      };
    case FETCH_HEARTBEAT_MONITOR_STATUS:
      return {
        ...state,
        heartbeatMonitorStatusLoading: true,
      };
    case FETCH_HEARTBEAT_MONITOR_STATUS_SUCCESS:
      return {
        ...state,
        heartbeatMonitorStatusLoading: false,
        heartbeatMonitorStatus: action.heartbeatMonitorStatus,
      };
    case FETCH_HEARTBEAT_MONITOR_STATUS_FAILURE:
      return {
        ...state,
        heartbeatMonitorStatusLoading: false,
      };
    default:
      return state;
  }
}
